import client, {QueryOptions, MutationOptions} from "@irati/utils/services/apollo"
import {Card, QueryLinkedCardsArgs, MutationRemoveCardArgs, User} from "@irati/types"
import onboardingService, {OnboardingStep} from "@irati/onboarding/services/onboarding"

import {perksGoLinkedCardList} from "./queries"
import {perksGoRemoveCard} from "./mutations"

class PerksGoService {
  getPerksGOCards = (variables: QueryLinkedCardsArgs, options: QueryOptions = {}): Promise<Card[]> => {
    return client.query({fetchPolicy: "network-only", ...options, query: perksGoLinkedCardList, variables}).then(({data}) => {
      return data.linkedCards?.results
    })
  }
  unlinkCard = (variables: MutationRemoveCardArgs, options: MutationOptions = {}): Promise<any> => {
    return client.mutate({...options, mutation: perksGoRemoveCard, variables})
  }
  hasLinkedCard = (user:User, options: QueryOptions = {}): Promise<boolean> => {
    const userId = user.uuid
    return this.getPerksGOCards({userId}, options).then((linkedCards) => {
      return linkedCards.length > 0
    })
  }
  shouldShowPerksGoBanner = (user: User, options: QueryOptions = {}): Promise<boolean> => {
    const userId = user.uuid
    return Promise.all([this.hasLinkedCard(user, options), onboardingService.get(userId, options)]).then(
      ([hasLinkedCard, {completedSteps}]) => {
        const hasDismissedLinkCardBanner = completedSteps.includes(OnboardingStep.HAS_DISMISSED_LINK_CARD_BANNER)
        if (hasLinkedCard && !hasDismissedLinkCardBanner) {
          this.hasDismissedLinkedCardBanner(user)
        }
        return !hasLinkedCard && !hasDismissedLinkCardBanner
      })
  }
  hasDismissedLinkedCardBanner = (user: User) => {
    onboardingService.completeStep(user, OnboardingStep.HAS_DISMISSED_LINK_CARD_BANNER)
  }
}

export default new PerksGoService()
